module.exports = __webpack_public_path__ + "static/img/as_1.f2be034.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/as_1.png
// module id = IblZ
// module chunks = 0